export type FsMapDrawingControlsType = {
  active: boolean;
  pen?: boolean;
  point?: boolean;
  polygon?: boolean;
  circle?: boolean;
  rectangle?: boolean;
  holdShiftForCircle?: boolean;
};

export enum FsDrawingToolsType {
  CIRCLE = 'circle',
  PEN = 'pen',
  POINT = 'point',
  POLYGON = 'polygon',
  POLYLINE = 'polyline',
  RECTANGLE = 'rectangle',
}
